import React, { useEffect, useState } from "react";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import MultiSelectDropdown from "../../../../components/comman/MultiSelectDropdown";
import ErrorMessage from "../../../../components/comman/ErrorMessage";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../../Sites/ViewDocumentModal";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../../components/comman/ConfirmModal";

export default function AddVendor() {
  const navigate = useNavigate();
  const location = useLocation();
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [newDocuments, setNewDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBankData, setIsLoadingBankData] = useState(false)

  const [state, setState] = useState({
    siteList: [],
    vendorTypeList: [],
    selectedTypes: [],
    selectedName: [],
    selectedSitesIds: [],
    selectedSites: [],
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
    control,
  } = useForm();
  const EditData = location?.state?.data;

  // Initialize existing documents from locationData
  useEffect(() => {
    if (EditData) {
      reset({
        firmName: EditData?.firmName,
        name: EditData?.name,
        email: EditData?.email,
        phone: EditData?.phone,
        gstNumber: EditData?.gstNumber,
        address: EditData?.address,
        city: EditData?.city,
        state: EditData?.state,
        panNumber: EditData?.panNumber,
        zipCode: EditData?.zipCode,
        bankName: EditData?.bankName,
        accountHolderName: EditData?.accountHolderName,
        branchName: EditData?.branchName,
        ifscCode: EditData?.ifscCode,
        branchAddress: EditData?.branchAddress,
        accountNumber: EditData?.accountNumber,
      });

      const preselectedSites = EditData?.usersites?.map((userSite) => ({
        id: userSite?.siteId,
        name: userSite?.site?.name,
      }));

      const preselectedTypes = (EditData?.type || []).map(
        (typeName) =>
          state.vendorTypeList.find((vendor) => vendor.name === typeName) || {
            id: typeName,
            name: typeName,
          }
      );

      setState((prev) => ({
        ...prev,
        selectedSites: preselectedSites,
        selectedSitesIds: preselectedSites?.map((site) => site.id),
        selectedTypes: preselectedTypes,
        selectedName: preselectedTypes.map((type) => type.name),
      }));

      if (EditData?.documents?.length > 0) {
        setExistingDocuments(EditData?.documents);
      }
    }
  }, [EditData, state.vendorTypeList]);

  useEffect(() => {
    GetSitesList();
    GetvendorType();
  }, []);

  const GetSitesList = () => {
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_site + `?type=site`}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          siteList: response?.data?.site,
        }));
      }
    });
  };

  const fetchBankDetails = async (ifsc) => {
    if (ifsc && ifsc.length === 11) {
      setIsLoadingBankData(true)
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
        if (response.ok) {
          const data = await response.json();
          setValue("bankName", data.BANK || "");
          setValue("branchName", data.BRANCH || "");
          setValue("branchAddress", data.ADDRESS || "");
        } else {
          toast.error("Invalid IFSC Code");
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
      } finally {
        setIsLoadingBankData(false)
      }
    } else {
      setIsLoadingBankData(false)
    }
  };

  const GetvendorType = () => {
    const option = {
      method: "GET",
    };
    callApi(apiUrl.get_expense_head_type + `?addingVendor=true`, option).then(
      (res) => {
        if (res.status === true) {
          setState((prev) => ({
            ...prev,
            vendorTypeList: res.data,
          }));
        }
      }
    );
  };

  // Add new document
  const addDocument = () => {
    const selectedDocument = watch("documentType");
    if (
      selectedDocument &&
      !newDocuments.some((doc) => doc[selectedDocument]) &&
      !existingDocuments.some((doc) => doc.name === selectedDocument)
    ) {
      setNewDocuments((prev) => [...prev, { [selectedDocument]: null }]);
      setValue("documentType", ""); // Reset dropdown
    }
  };

  // Handle file selection for new documents
  const handleFileChange = (key, file, event) => {
    if (file && file.size > 6 * 1024 * 1024) {
      toast.error("File size must be less than 6MB");
      if (event) event.target.value = "";
      return;
    }
    setNewDocuments((prev) =>
      prev.map((doc) => (doc[key] !== undefined ? { [key]: file } : doc))
    );
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const removeNewDocument = (key) => {
    setNewDocuments((prev) => prev.filter((doc) => !doc.hasOwnProperty(key)));
  };

  // Delete an existing document via API
  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  const onSubmit = (data) => {
    if (state.selectedSites.length === 0) {
      toast.error("Please select site");
      return;
    }
    if (state.selectedTypes.length === 0) {
      toast.error("Please select vendor type");
      return;
    }
    const invalidDocuments = newDocuments?.some((doc) => {
      return Object.values(doc).includes(null);
    });
    if (invalidDocuments) {
      toast.error("Please select file for Document");
      return;
    }
    const postData = {
      firmName: data?.firmName,
      name: data?.name,
      email: data?.email,
      phone: data?.phone,
      type: JSON.stringify(state?.selectedName),
      gstNumber: data?.gstNumber,
      address: data?.address,
      city: data?.city,
      state: data?.state,
      panNumber: data?.panNumber,
      zipCode: data?.zipCode,
      ifscCode: data?.ifscCode,
      bankName: data?.bankName,
      branchName: data?.branchName,
      branchAddress: data?.branchAddress,
      accountHolderName: data?.accountHolderName,
      accountNumber: data?.accountNumber,
      selectedSite: JSON.stringify(state?.selectedSitesIds),
    };

    // console.log(newDocuments);

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    newDocuments.forEach((doc) => {
      const [key, file] = Object.entries(doc)[0];
      if (file) {
        formData.append(key, file);
      }
    });

    const option = {
      method: "POST",
      form_data: formData,
    };

    // console.log(postData);

    const endPoint = EditData
      ? apiUrl.update_vendor + `?vendorId=${EditData?.id}`
      : apiUrl.create_vendor;
    setIsLoading(true);
    callApi(endPoint, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        toast.success(res?.message);
        navigate(-1);
        reset();
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleSiteChange = (selectedOptions) => {
    const selectedSiteIds = selectedOptions?.map((item) => item.id) || [];
    setState((prevState) => ({
      ...prevState,
      selectedSites: selectedOptions,
      selectedSitesIds: selectedSiteIds,
    }));
  };

  const handleVendorTypeChange = (selectedOptions) => {
    const selectedNames = selectedOptions?.map((item) => item.name) || [];
    setState((prevState) => ({
      ...prevState,
      selectedTypes: selectedOptions,
      selectedName: selectedNames,
    }));
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">{EditData ? "Update" : "Add"} Vendor</h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-BasicDetails"
                  role="tabpanel"
                  aria-labelledby="pills-BasicDetails-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <div className="col-12">
                      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                        Details
                      </h4>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="Role" className="form-label">
                          Site <span className="text-danger">*</span>
                        </label>
                        <MultiSelectDropdown
                          options={state?.siteList || []}
                          selectedValues={state.selectedSites}
                          onChange={(option) => handleSiteChange(option)}
                          multiSelect={true}
                        />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="vendorType" className="form-label">
                          Vendor Type <span className="text-danger">*</span>
                        </label>
                        <MultiSelectDropdown
                          options={state?.vendorTypeList || []}
                          selectedValues={state?.selectedTypes}
                          onChange={(option) => handleVendorTypeChange(option)}
                          multiSelect={true}
                          MultiSelectDropdown
                          placeholder="Select Vendor Type"
                        />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="firmName" className="form-label">
                          Firm Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.firmName ? "is-invalid" : ""
                            }`}
                          placeholder="Firm Name"
                          {...register("firmName", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.firmName?.message} />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="contactPerson" className="form-label">
                          Contact Person <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.name ? "is-invalid" : ""
                            }`}
                          placeholder="Contact Person Name"
                          {...register("name", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.name?.message} />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className={`form-control `}
                          placeholder="Enter Email"
                          {...register("email", {
                            // required: "This field is Required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email",
                            },
                          })}
                        />
                        <ErrorMessage message={errors?.email?.message} />
                      </div>
                    </div>
                    {/* Contact Number */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="contactNumber" className="form-label">
                          Contact Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.phone ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Contact No."
                          id="contactNumber"
                          {...register("phone", {
                            required: "Contact Number is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Phone Number must be 10 digits",
                            },
                          })}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ); // Allow
                          }}
                        />
                        <ErrorMessage message={errors?.phone?.message} />
                      </div>
                    </div>

                    {/* State */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="state" className="form-label">
                          State <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.state ? "is-invalid" : ""
                            }`}
                          id="state"
                          placeholder="Enter State"
                          {...register("state", {
                            required: "State is required",
                          })}
                        />
                        <ErrorMessage message={errors?.state?.message} />
                      </div>
                    </div>

                    {/* City */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="city" className="form-label">
                          City <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.city ? "is-invalid" : ""
                            }`}
                          id="city"
                          placeholder="Enter City"
                          {...register("city", {
                            required: "City is required",
                          })}
                        />
                        <ErrorMessage message={errors?.city?.message} />
                      </div>
                    </div>

                    {/* State Code */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="stateCode" className="form-label">
                          Zip Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          className={`form-control ${errors.zipCode ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Zip Code"
                          id="stateCode"
                          {...register("zipCode", {
                            required: "Zip Code is required",
                          })}
                        />
                        <ErrorMessage message={errors?.zipCode?.message} />
                      </div>
                    </div>

                    {/* Address */}
                    <div className="col-12 col-md-6 col-lg-4 w-100">
                      <div className="form-group mb-3">
                        <label htmlFor="Address" className="form-label">
                          Address <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className={`form-control ${errors.address ? "is-invalid" : ""
                            }`}
                          id="Address"
                          rows={3}
                          placeholder="Enter Address"
                          {...register("address", {
                            required: "This field is required",
                          })}
                        />
                        <ErrorMessage message={errors?.address?.message} />
                      </div>
                    </div>

                    {/* GST Number */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="gstNumber" className="form-label">
                          GST Number
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.gstNumber ? "is-invalid" : ""
                            }`}
                          placeholder="Enter GST Number"
                          id="gstNumber"
                          {...register("gstNumber", {
                            // required: "GST Number is required",
                            // pattern: {
                            //   value: /^[0-9]{15}$/,
                            //   message: "GST Number must be 15 digits",
                            // },
                          })}
                        />
                        <ErrorMessage message={errors?.gstNumber?.message} />
                      </div>
                    </div>
                    {/* PAN Number */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="pan" className="form-label">
                          PAN Number
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.panNumber ? "is-invalid" : ""
                            }`}
                          placeholder="Enter PAN Number"
                          id="pan"
                          {...register("panNumber", {
                            // required: "PAN Number is required",
                            pattern: {
                              value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                              message:
                                "Invalid PAN format. Example: ABCDE1234F",
                            },
                          })}
                          onChange={(e) => {
                            // Allow only uppercase letters and digits, strip out invalid characters
                            e.target.value = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9]/g, "");
                          }}
                        />
                        <ErrorMessage message={errors?.panNumber?.message} />
                      </div>
                    </div>

                    <div className="col-12">
                      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                        Bank Details
                      </h4>
                    </div>

                    {/* Bank Account */}
                    <div className="col-12 col-md-4">
                      <div className="form-group mb-3">
                        <label htmlFor="acnum" className="form-label">
                          Account Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.accountNumber ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Account Number"
                          id="acnum"
                          {...register("accountNumber", {
                            required: "This field is required",
                            pattern: {
                              value: /^\d+(\.\d+)?$/,
                              message: "Please enter a valid number",
                            },
                          })}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^0-9.]/g,
                              ""
                            ); // Allow only numbers and dots
                            e.target.value = value;
                          }}
                        />

                        <ErrorMessage
                          message={errors?.accountNumber?.message}
                        />
                      </div>
                    </div>

                    {/* Ac Holder Name */}
                    <div className="col-12 col-md-4">
                      <div className="form-group mb-3">
                        <label htmlFor="acholdername" className="form-label">
                          A/C Holder Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.accountHolderName ? "is-invalid" : ""
                            }`}
                          placeholder="Enter A/C Holder Name"
                          id="acholdername"
                          {...register("accountHolderName", {
                            required: "This field is required",
                          })}
                        />
                        <ErrorMessage
                          message={errors?.accountHolderName?.message}
                        />
                      </div>
                    </div>

                    {/* IFSC Code */}
                    <div className="col-12 col-md-4">
                      <div className="form-group mb-3">
                        <label htmlFor="IFSC" className="form-label">
                          IFSC Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="IFSC"
                          placeholder="Enter IFSC/RTGS Code"
                          maxLength={11}
                          {...register("ifscCode", {
                            required: "This field is Required",
                            pattern: {
                              value: /^[A-Z0-9]*$/,
                              message: "It must contain only numbers and letters",
                            },
                            onChange: (e) => {
                              e.target.value = e.target.value.toUpperCase();
                              if (e.target.value.length === 11) {
                                fetchBankDetails(e.target.value);
                              } else {
                                setValue("bankName", "");
                                setValue("branchName", "");
                                setValue("branchAddress", "");
                              }
                            }
                          })}
                        />
                        <ErrorMessage message={errors?.ifscCode?.message} />
                      </div>
                    </div>

                    {/* Bank Name */}
                    <div className="col-12 col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="bankname" className="form-label">
                          Bank Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.bankName ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Bank Name"
                          id="bankname"
                          {...register("bankName", {
                            required: "This field is required",
                          })}
                          disabled
                        />
                        <ErrorMessage message={errors?.bankName?.message} />
                      </div>
                    </div>

                    {/* Branch Name */}
                    <div className="col-12 col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="branchname" className="form-label">
                          Branch Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.branchName ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Branch Name"
                          id="branchname"
                          {...register("branchName", {
                            required: "This field is required",
                          })}
                          disabled
                        />
                        <ErrorMessage message={errors?.branchName?.message} />
                      </div>
                    </div>

                    {/* Branch Address */}
                    <div className="col-12">
                      <div className="form-group mb-3">
                        <label htmlFor="branchAddress" className="form-label">
                          Branch Address <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          <textarea
                            className="form-control"
                            id="branchAddress"
                            placeholder={isLoadingBankData ? "Loading..." : "Enter Branch Address"}
                            rows={2}
                            defaultValue={""}
                            {...register("branchAddress", {
                              required: "This field is Required",
                            })}
                            disabled
                          />
                          {isLoadingBankData && (
                            <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                              <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <ErrorMessage message={errors?.branchAddress?.message} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                          Documents
                        </h4>
                      </div>

                      {/* {/ Document Selector /} */}
                      <div className="col-12 col-md-6 col-lg-4">
                        <div className="form-group mb-3">
                          <label htmlFor="documentType" className="form-label">
                            Select Documents
                          </label>
                          <select
                            className="form-select form-control"
                            {...register("documentType")}
                          >
                            <option value="" className="d-none">
                              Select Documents
                            </option>
                            {[
                              "Pan_Card",
                              "GST_Registration_Document",
                              "Upload_Cancel_check",
                            ].map((doc) => (
                              <option
                                key={doc}
                                value={doc}
                                disabled={
                                  newDocuments.some((d) => d[doc]) ||
                                  existingDocuments.some((d) => d.name === doc)
                                }
                              >
                                {doc.replace(/_/g, " ")}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-4 align-self-end">
                        <div className="form-group mb-3">
                          <button
                            className="btn btn-outline-primary px-4"
                            type="button"
                            onClick={addDocument}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* {/ Existing Documents /} */}
                    <div className="row">
                      {existingDocuments?.map((doc) => (
                        <div
                          key={doc.id}
                          className="col-12 col-md-6 col-lg-4 mt-3 mb-5 d-flex justify-content-between align-items-center"
                        >
                          <h4
                            className="mb-3"
                            role="button"
                            title="View Document"
                            onClick={() => handleDocumentClick(doc)}
                          >
                            {doc.name.replace(/_/g, " ")}
                          </h4>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => ActionHandler(doc.id)}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      ))}
                    </div>
                    {/* {/ New Documents /} */}
                    <div className="row">
                      {newDocuments.map((doc, index) => {
                        const key = Object.keys(doc)[0];
                        return (
                          <div
                            key={index}
                            className="col-12 col-md-6 col-lg-4 mb-3 "
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                              <h4 className="mb-3 ">
                                {key.replace(/_/g, " ")}
                              </h4>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => removeNewDocument(key)}
                              >
                                Remove
                              </button>
                            </div>
                            <div className="img-uploader">
                              <input
                                type="file"
                                accept={
                                  key === "Company_Logo" ? "image/*" : ".pdf"
                                }
                                className="form-control"
                                onChange={(e) =>
                                  handleFileChange(key, e.target.files[0], e)
                                }
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end gap-4">
                    <button
                      className="btn btn-secondary px-5"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-primary px-5" type="submit">
                      {isLoading ? <Spinner /> : EditData ? "Update" : "Create"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
    </>
  );
}
